export default __webpack_public_path__ + "static/media/logomadlex-ma.1e8c7b64.png";